var map = {
	"./art.jpg": 640,
	"./chevaux.jpg": 37,
	"./couronne.jpg": 904,
	"./heritage-b.jpg": 945,
	"./heritage-c.jpg": 596,
	"./heritage-mobile.jpg": 749,
	"./heritage.jpg": 240,
	"./staff.jpg": 753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 832;